const n = (i, t, r) => (
  // changed undefined locale to 'en-US' as we need prices format to show constantly across different users' browser locales
  // Check discussion here https://lokalise.atlassian.net/browse/CC-688?focusedCommentId=35768
  i.toLocaleString("en-US", {
    style: "currency",
    currency: t,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...r
  })
);
export {
  n as formatCurrency
};
//# sourceMappingURL=formatCurrency.js.map
